/** @format */

import { api } from "../../app/services/api";

export const ckEditorApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCloudJWT: build.query<string, void>({
      query: () => ({
        url: "cke/cloud-jwt",
        responseHandler: "text",
      }),
    }),
  }),
});

export const { useGetCloudJWTQuery } = ckEditorApi;
